/**
* Service Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-tabs' ).length ) {
        const sliders = [];
        const wrapper = document.querySelector( '.service-tabs' );
        const buttons = wrapper.querySelectorAll( '.service-tabs__button' );

        // Toggle "dropdown" mode when active button is clicked on mobile
        buttons.forEach( ( button ) => {
          button.addEventListener( 'click', ( e ) => {
            if ( window.innerWidth <= 768 ) {
              const isActive = button.classList.contains( 'is-open' );
              const isDropdown = wrapper.classList.contains( 'service-tabs__dropdown-open' );

              // If already open and clicking active, toggle dropdown
              if ( isActive ) {
                wrapper.classList.toggle( 'service-tabs__dropdown-open' );
                e.preventDefault(); // Prevent immediate tab change
              } else {
                // Selecting a new tab closes dropdown
                wrapper.classList.remove( 'service-tabs__dropdown-open' );
              }
            }
          } );
        } );

        // Mount each slider
        $( '.service-tabs__slider.splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            // arrows: true by default, so it will use the arrows inside this slider
            breakpoints: {
              1024: {perPage: 2},
              768: {perPage: 1, gap: '1rem', arrows: false},
            },
          } );

          splide.on( 'overflow', function( isOverflow ) {
            splide.go( 0 );
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
            };
          } );

          splide.mount();
          sliders[index] = splide;
        } );

        // Mobile dropdown -> trigger tab change
        $( '.service-tabs__select' ).on( 'change', function() {
          const key = $( this ).val();
          $( `.service-tabs__button[data-splide-key="${key}"]` ).trigger( 'click' );
          sliders[key].refresh();
        } );

        // Refresh the slider when its tab is shown
        $( '.service-tabs__button' ).on( 'click', function() {
          const splideKey = $( this ).data( 'splide-key' );
          sliders[splideKey].refresh();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-tabs', COMPONENT );
} )( app );
